<template>
  <div class="modal-wrapper">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" @click="$emit('close')" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <h4 class="modal-title">
            Alterar External Id
          </h4>
        </div>
        <div class="modal-body--scrollable">
          <table class="table table-striped modal__table">
            <tbody>
              <tr>
                <th class="spaced-title">
                  Id da mensalidade
                </th>
                <td class="spaced-cell">
                  {{ selectedBill.id }}
                </td>
              </tr>
              <tr>
                <th class="spaced-title">
                  Id Externo atual
                </th>
                <td class="spaced-cell">
                  {{ selectedBill.external_id || '-' }}
                </td>
              </tr>
            </tbody>
          </table>
          <div class="modal-body">
            <div v-if="inputError" class="alert alert-danger">
              {{ inputError }}
            </div>
            <p>Novo External ID:</p>
            <input class="form-control" type="number" v-model="newExternalId">
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn btn-primary" @click="editExternalId" :disabled="!newExternalId">
            Salvar
          </button>
          <button class="btn btn-default" @click="$emit('close')">
            Fechar
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BillsService from 'services/BillsService';

export default {
  data() {
    return {
      newExternalId: null,
      inputError: null,
    };
  },
  computed: {
    ...mapState([
      'selectedBill',
    ]),
  },
  methods: {
    ...mapActions([
      'loadStudentBills',
    ]),
    editExternalId() {
      if (this.newExternalId === this.selectedBill.external_id) {
        this.inputError = 'O novo External ID é igual ao External ID atual.';
        return;
      }

      this.inputError = null;
      this.$loader.show();
      BillsService.editExternalId(this.selectedBill.id, this.newExternalId)
        .then(() => {
          this.$alert.notifySuccess('External ID alterado com sucesso.');
          this.loadStudentBills();
          this.$emit('close');
        })
        .catch((error) => {
          this.inputError = error?.response?.data?.message || 'Erro ao atualizar: contate o suporte.';
        })
        .finally(() => this.$loader.hide());
    },
  },
};
</script>

<style scoped>
.spaced-cell {
  padding-left: 5px;
}
.spaced-title{
  padding-left: 16px;
}
</style>
